import { getAncestorsByCriteria } from '../../../lib/dom'
import { expandCollapsibleObject, isExpanded, WRAPPER_CLASS } from './externalControl'
import { not } from '../../../lib/functionChaining'

const RJSF_INVALID_FIELD_CSS_SELECTOR = '.field.has-error'
const getFirstInvalidField = (formHtmlElement: HTMLFormElement) => {
  return formHtmlElement?.querySelector(RJSF_INVALID_FIELD_CSS_SELECTOR) as HTMLDivElement
}

export const scrollToFirstInvalidField = async (
  formHtmlElement: HTMLFormElement
): Promise<void> => {
  const elementToReveal = getFirstInvalidField(formHtmlElement)

  if (!elementToReveal) {
    return
  }

  await expandPathToElement(elementToReveal)
  elementToReveal.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

const expandPathToElement = (elementToReveal: HTMLElement): Promise<void> => {
  const collapsableAncestors = getAncestorsByCriteria(elementToReveal, `.${WRAPPER_CLASS}`)

  const collapsedAncestors = collapsableAncestors.filter(not(isExpanded))

  collapsedAncestors.forEach(expandCollapsibleObject)
  // Did async setState (caused by clicking collapsed ancestors) materialize into expanded UI ?
  const didObjectsFinishExpandingYet = () => collapsedAncestors.every(isExpanded)

  const resolveWhenDone = new Promise<void>(resolve => {
    const initialTimestamp = Date.now()

    const invervalId = setInterval(() => {
      if (didObjectsFinishExpandingYet()) {
        clearInterval(invervalId)
        resolve()
      }

      if (Date.now() - initialTimestamp > 3000) {
        clearInterval(invervalId)
      }
    }, 70)
  })

  return resolveWhenDone
}
